export function assert(condition: unknown, message?: string): asserts condition {
  if (!condition) {
    throw new Error(message ?? 'Condition expected to be true');
  }
}

export function assertUnreachable(): never {
  throw new Error('Code unreachable');
}
